<script>
import moment from 'moment';
import FormInput from '@/components/form/FormInput.vue';
import FormInputCPF from 'CPF';
import AppButton from '@/components/ui/AppButton.vue';
import Button from '@/components/form/Button.vue';
import Radiobox from '@/components/form/Radiobox.vue';
import Icons from '@/components/Icons.vue';
import ProductRegisterFlow from '@/components/product/ProductRegisterFlow.vue';
import { googleAnalyticsEvent, googleAnalyticsParamEvent, GA_EVENTS } from '../utils/googleAnalyticsEvents';
import { ttqTrackEvent, fbqTrackEvent } from '../utils/metaEvents';
import { clearStoredReferrer, getStoredReferrer } from '@/services/referrer.service';
import { MGM_EXT_ORIGIN } from '@/services/mgmReferralLink';
import ValidateMail from '@/components/ValidateMail.vue';
import disposableDomains from 'disposable-email-domains';

const friendReferralCardImage = new URL('@/assets/img/simbolo-pop.png', import.meta.url).href;

export default {
	name: 'Entrar',
	components: {
		FormInput,
		FormInputCPF,
		AppButton,
		Button,
		Radiobox,
		Icons,
		ProductRegisterFlow,
		ValidateMail
	},
	data() {
		return {
			cadastroProdutos: true,
			signUpForm: {
				name: "",
				lastName: "",
				cellphone: "",
				birthday: "",
				email: "",
				taxId: "",
				address: "",
				complement: "",
				zipCode: "",
				password: "",
				confirmPassword: "",
				optInAge: false,
				optInTerms: false,
				optInCookie: false,
				optInPrivacy: false,
				optInCommunication: false,
			},
			dateForm: {
				day: '',
				month: '',
				year: '',
			},
			sending: false,
			feedback: '',
			created: 'cadastro',
			category: '',
			categories: [],
			subCategory: '',
			subCategories: [],
			memberId: '',
			productName: '',
			isRegisteringProduct: false,
			token: '',
			regexCellphone: '',
			validateMessageType: '',
			validateMessageFeedback: false,
			showPassword: false,
			showConfirmPassword: false,
			isSubmitting: false,
			zipCodeError: false,
			zipCodeErrorMessage: '',
			friendReferralCardImage,
			referralCode: '',
			referralSource: 'indicacao',
			hasReferralCode: null,
			referralPrefillFromMgm: false,
			referralPrefillFromPromoter: false,
			referralPromoterExtOriginType: '',
			referralCodeLockedFromMgm: false,
			referralCodeLockedFromPromoter: false,
		};
	},
	created() {
		// SEO ======
		document.title = this.$t('meta.cadastro.title');
		document.querySelector('meta[name="description"]').setAttribute('content', this.$t('meta.cadastro.description'));
		document.querySelector('meta[name="keywords"]').setAttribute('content', this.$t('meta.cadastro.keywords'));

		// Definindo as Meta Tags de Open Graph (og:*)
		document.querySelector('meta[property="og:title"]').setAttribute('content', this.$t('meta.cadastro.title'));
		document.querySelector('meta[property="og:description"]').setAttribute('content', this.$t('meta.cadastro.description'));
		// // Definindo as Meta Tags do Twitter
		document.querySelector('meta[name="twitter:title"]').setAttribute('content', this.$t('meta.cadastro.title'));
		document.querySelector('meta[name="twitter:description"]').setAttribute('content', this.$t('meta.cadastro.description'));
		// SEO ======


		if (this.$router.currentRoute.value.path.includes('validate-user') &&
			this.$route.query?.token) {
			this.token = `Bearer ${this.$route.query.token}`
			const gaEventName = GA_EVENTS.ACCOUNT_CONFIRMED
			const gaParameters = {
				local_time_date: new Date().toISOString(),
			}
			googleAnalyticsEvent(gaEventName, gaParameters)
			googleAnalyticsParamEvent(['lgfamilyclub', gaEventName, window.location.pathname, window.location.href])
			fbqTrackEvent('Lead')
			fbqTrackEvent('CompleteRegistration')
			ttqTrackEvent('CompleteRegistration')

			this.validateMemberAccount()
		}

	},
	mounted() {
		this.getCategories()
		this.initReferralFromStorage()
		const signupToken = this.$route.query?.signup
		if (signupToken) {
			this.preSignup(signupToken)
		}
	},
	methods: {
		getReferralKeyValue(stored, key) {
			if (!stored?.keyValues?.length) return ''
			const k = key.toLowerCase()
			const found = stored.keyValues.find((kv) => (kv.key || '').toLowerCase() === k)
			return (found?.value ?? '').toString().trim()
		},
		hasReferralKey(stored, key) {
			if (!stored?.keyValues?.length) return false
			const k = key.toLowerCase()
			return stored.keyValues.some((kv) => (kv.key || '').toLowerCase() === k)
		},
		initReferralFromStorage() {
			const stored = getStoredReferrer()
			const q = this.$route.query || {}
			const mgmFromQuery = (q.extMGM ?? '').toString().trim()
			const promoterFromQuery = (q.extPromoterId ?? '').toString().trim()
			const typeQ = (q.extOrigin ?? '').toString().trim().toUpperCase()
			const typeS = (stored?.type ?? '').toString().trim().toUpperCase()
			const mgmCode = this.getReferralKeyValue(stored, 'MGM') || mgmFromQuery
			const promoterId = this.getReferralKeyValue(stored, 'PromoterId') || promoterFromQuery
			const extMgmReceived = q.extMGM !== undefined && q.extMGM !== null
			const extPromoterIdReceived = q.extPromoterId !== undefined && q.extPromoterId !== null
			const lockFromMgm = extMgmReceived || this.hasReferralKey(stored, 'MGM')
			const lockFromPromoter = extPromoterIdReceived || this.hasReferralKey(stored, 'PromoterId')
			const isMgmFlow =
				typeQ === MGM_EXT_ORIGIN ||
				typeS === MGM_EXT_ORIGIN ||
				!!mgmCode

			if (isMgmFlow) {
				this.referralPrefillFromMgm = !!(typeQ === MGM_EXT_ORIGIN || typeS === MGM_EXT_ORIGIN || mgmCode)
				this.referralPrefillFromPromoter = false
				this.referralSource = 'indicacao'
				this.referralCode = mgmCode
				this.referralPromoterExtOriginType = ''
				this.referralCodeLockedFromMgm = lockFromMgm
				this.referralCodeLockedFromPromoter = false
				this.hasReferralCode = true
				return
			}
			if (promoterId || lockFromPromoter) {
				this.referralPrefillFromMgm = false
				this.referralPrefillFromPromoter = !!promoterId
				this.referralSource = 'vendedor'
				this.referralCode = promoterId
				this.referralPromoterExtOriginType = (stored?.type ?? '').toString().trim()
				this.referralCodeLockedFromMgm = false
				this.referralCodeLockedFromPromoter = lockFromPromoter
				this.hasReferralCode = true
				return
			}
			this.referralPrefillFromMgm = false
			this.referralPrefillFromPromoter = false
			this.referralSource = 'indicacao'
			this.referralCode = ''
			this.referralPromoterExtOriginType = ''
			this.referralCodeLockedFromMgm = false
			this.referralCodeLockedFromPromoter = false
			this.hasReferralCode = null
		},
		toggleHasReferralCode(value) {
			this.hasReferralCode = this.hasReferralCode === value ? null : value
			if (!this.hasReferralCode) {
				this.referralCode = ''
				this.referralSource = 'indicacao'
			}
		},
		buildExternalOriginKeyValuesForSubmit() {
			const code = getStoredReferrer()
			if (!code) return null

			return code
		},
		toggleShowPassword() {
			this.showPassword = !this.showPassword;
		},
		toggleShowConfirmPassword() {
			this.showConfirmPassword = !this.showConfirmPassword;
		},
		preSignup(token) {
			this.$store.dispatch("auth/preSignup", token).then(
				(resp) => {
					if (resp?.data?.data) {
						this.signUpForm.name = resp?.data?.data?.name
						this.signUpForm.lastName = resp?.data?.data?.lastName
						this.signUpForm.cellphone = resp?.data?.data?.cellphone
						this.signUpForm.email = resp?.data?.data?.email

						const date = moment(resp?.data?.data?.birthday);
						if (date.isValid()) {
							this.dateForm.day = date.format("DD");
							this.dateForm.month = date.format("M");
							this.dateForm.year = date.format("YYYY");

							this.signUpForm.birthday = resp?.data?.data?.birthday;
						}
					}
				},
				(error) => {
					console.log(this.error)
				}).catch(error => {
					console.log(error)
				});
		},
		interceptAccess(to, element, content, index) {
			if (!to) return
			if (to.indexOf('https') >= 0) {
				googleAnalyticsEvent(['lgfamilyclub', element, content, index, to])
				return window.open(to, '_blank')
			}
			googleAnalyticsEvent(['lgfamilyclub', element, content, index, window.location.host + to])
			this.$router.push(to)
		},
		sequenceValidation(val) {
			const str = val.toLowerCase();
			const codigoA = 'a'.charCodeAt(0);
			const codigoZ = 'z'.charCodeAt(0);
			const codigo0 = '0'.charCodeAt(0);
			const codigo9 = '9'.charCodeAt(0);

			for (let i = 0; i < val.length - 2; i++) {
				const codigoAtual = val.charCodeAt(i);
				const codigoProximo = val.charCodeAt(i + 1);
				const codigoProximo2 = val.charCodeAt(i + 2);

				if (codigoAtual >= codigoA && codigoAtual <= codigoZ &&
					codigoProximo === codigoAtual + 1 &&
					codigoProximo2 === codigoAtual + 2) {
					return true;
				}

				// Verifica sequência numérica
				if (codigoAtual >= codigo0 && codigoAtual <= codigo9 &&
					codigoProximo === codigoAtual + 1 &&
					codigoProximo2 === codigoAtual + 2) {
					return true;
				}
			}
			return false;
		},
		above18() {
			return moment().subtract(18, 'years').format('YYYY-MM-DD');
		},
		toggleCadastroProdutos() {
			this.cadastroProdutos = !this.cadastroProdutos;
		},
		showProdutos() {
			this.cadastroProdutos = true;
		},
		showFinalizar() {
			this.cadastroProdutos = false;
		},
		getCategories() {
			this.$store.dispatch("product/getCategories").then(
				(resp) => {
					this.categories = resp.data;
				},
				(error) => {
					console.log(error)
				}
			).catch(error => {
				console.log(error)
			});
		},
		getSubCategories(id) {
			this.$store.dispatch("product/getSubCategories", this.category).then(
				(resp) => {
					this.subCategories = resp.data;
				},
				(error) => {
					console.log(error)
				}
			).catch(error => {
				console.log(error)
			});
		},
		sendSignUp(event) {
			this.feedback = ''
			this.sending = true

			event.preventDefault()

			if (this.isValid) {
				try {
					this.isSubmitting = true

					const gaEventName = GA_EVENTS.SIGNED_UP
					const gaParameters = {
						local_time_date: new Date().toISOString(),
					}

					googleAnalyticsEvent(gaEventName, gaParameters)
					googleAnalyticsParamEvent(['lgfamilyclub', gaEventName, window.location.pathname, window.location.href])
					fbqTrackEvent('Lead')
					fbqTrackEvent()
					ttqTrackEvent()

					const extPayload = this.buildExternalOriginKeyValuesForSubmit()

					let formDataToSend = { ...this.signUpForm };

					// const { day, month, year } = this.dateForm;
					// if (day && month && year)
					// 	this.signUpForm.birthday = moment(`${year}-${month}-${day}`, "YYYY-MM-DD");

					const formatted = moment(this.signUpForm.birthday, "DDMMYYYY").format("YYYY-MM-DD");
					formDataToSend.birthday = formatted;

					if (formDataToSend.taxId.trim() === '')
						delete formDataToSend.taxId

					if (extPayload) {
						formDataToSend.externalOriginKeyValues = extPayload
					}

					this.$store.dispatch("auth/registerMember", formDataToSend).then(
						(resp) => {
							clearStoredReferrer()
							this.$router.push({ name: 'active-account' });
						},
						(error) => {
							this.isSubmitting = false
								if (error?.response?.data?.message === 'user-is-member') {
									this.feedback = this.$t('signUp.userAlreadyMember')
							} else {
								this.feedback = this.$t('signUp.generalError')
							}
						}).catch(error => {
							this.isSubmitting = false
							this.feedback = this.$t('signUp.generalError')
						});
				} catch (error) {
					this.isSubmitting = false
					this.feedback = this.$t('signUp.generalError')
				}
			} else {
				this.feedback = this.$t('signUp.requiredFields')
			}
		},
		onFlowCategory(categoryId) {
			this.category = categoryId
			this.subCategories = []
			this.getSubCategories(categoryId)
		},
		onFlowSave(payload) {
			if (this.isRegisteringProduct) return
			this.isRegisteringProduct = true
			this.$store.dispatch("product/registerProduct", { token: this.token, subCategoryId: payload.subCategoryId, name: payload.name }).then(
				() => {
					this.$router.push({ name: 'signin', query: { ativarConta: true } })
				},
				(error) => {
					console.log(error)
				}
			).catch((error) => {
				console.log(error)
			}).finally(() => {
				this.isRegisteringProduct = false
			})
		},
		sendProduct(event) {
			event.preventDefault()

			this.$store.dispatch("auth/registerProduct", { memberId: this.memberId, subCategoryId: this.subCategory, name: this.productName }).then(
				(resp) => {
					this.$router.push({
						name: 'signin',
						query: { ativarConta: true }
					});
				},
				(error) => {
					console.log(error)
				}
			).catch(error => {
				console.log(error)
			});
		},
		validateMemberAccount() {
			this.$store.dispatch("user/update", { token: this.token, member: { isValidated: true } }).then(
				(resp) => {
					if (resp?.status === 203) {
						this.created = 'validate';
						this.validateMessageType = 'validated';
					} else {
						this.created = "finalizacao";
					}
				},
				(error) => {
					console.log(error)
					const errorMessage = error.response?.data?.error?.message

					if (errorMessage === 'activation-email-expired') {
						this.created = 'validate';
						this.validateMessageType = 'expired';
					} else {
						this.created = 'finalizacao';
						this.feedback = this.$t('signUp.generalError')
					}
				}
			).catch(error => {
				console.log(error)
			});
		},
		resendValidationEmail() {
			const body = { token: this.token }
			this.$store.dispatch("auth/resendValidationEmail", body)
				.then((resp) => {
					this.created = 'validate';
					this.validateMessageFeedback = true
				})
				.catch((error) => {
					console.log(error);
					const message = error.response?.data?.error?.message

					if (message === 'activation-email-already-sent') {
						this.validateMessageType = 'under24'
						this.validateMessageFeedback = false
						this.created = 'validate'
					} else {
						console.log(error)
						this.created = 'finalizacao';
						this.feedback = this.$t('signUp.generalError')
					}
				})
		},
		log(val) {
			// console.log(val)
		},
		getRegexCellphone: function () {
			if (!this.regexCellphone)
				this.regexCellphone = new RegExp(`^\\d{${this.cellphoneQtd}}$`)

			return this.regexCellphone
		},
		isTemporaryEmail: function (email) {
			const domain = email.split('@')[1]?.toLowerCase();
			return disposableDomains.includes(domain);
		},
		isPlusAliasBlocked: function (email) {
			const [localPart = '', domain = ''] = (email || '').trim().toLowerCase().split('@');
			if (!localPart || !domain) return false;
			return localPart.includes('+') && domain !== 'lgcns.com';
		},
		onCepBlur() {
			const raw = this.signUpForm.zipCode || '';
			const clean = raw.replace(/\D/g, '');

			this.zipCodeError = false;
			this.zipCodeErrorMessage = '';

			if (clean.length === 0 || clean.length !== 8) {
				this.zipCodeError = true;
				this.zipCodeErrorMessage = 'Por favor, preencha seu CEP.';
				return;
			}

			this.$store.dispatch('address/lookupCep', raw)
				.then((result) => {
					if (!result) {
						this.zipCodeError = true;
						this.zipCodeErrorMessage = 'CEP não encontrado. Por favor, preencha o endereço manualmente.';
						return;
					}
					const parts = [result.street, result.neighborhood, result.city, result.state].filter(Boolean);
					this.signUpForm.address = parts.join(' - ');

					this.zipCodeError = false;
					this.zipCodeErrorMessage = '';
				})
				.catch(() => {
					this.zipCodeError = true;
					this.zipCodeErrorMessage = 'CEP não encontrado. Por favor, preencha o endereço manualmente.';
				});
		},
	},
	watch: {
		'signUpForm.zipCode'() {
			this.zipCodeError = false;
			this.zipCodeErrorMessage = '';
		},
	},
	computed: {
		cpfEnabled() {
			return __CPF_ENABLED__
		},
		signUpBenefits() {
			return [
				{ icon: 'authCampaign', title: this.$t('signUp.benefits.campaigns.title'), description: this.$t('signUp.benefits.campaigns.description') },
				{ icon: 'authRewards', title: this.$t('signUp.benefits.rewards.title'), description: this.$t('signUp.benefits.rewards.description') },
				{ icon: 'authCommunity', title: this.$t('signUp.benefits.community.title'), description: this.$t('signUp.benefits.community.description') },
				{ icon: 'authExperiences', title: this.$t('signUp.benefits.experiences.title'), description: this.$t('signUp.benefits.experiences.description') }
			]
		},
		profileSectionComplete() {
			return this.signUpValidation.email &&
				this.signUpValidation.emailDomain &&
				this.signUpValidation.name &&
				this.signUpValidation.lastName &&
				this.signUpValidation.birthday &&
				this.signUpValidation.cellphone &&
				this.signUpValidation.taxId
		},
		securitySectionComplete() {
			return this.signUpValidation.password &&
				this.signUpValidation.passLenght &&
				this.signUpValidation.passCarecteres &&
				this.signUpValidation.passEmail &&
				this.signUpValidation.passSequence &&
				this.signUpValidation.confirmPassword
		},
		referralSectionComplete() {
			return this.hasReferralCode === false ||
				(this.hasReferralCode === true && !!this.referralCode.trim())
		},
		cellphoneQtd: function () {
			return this.$t('form.labels.telMask').split('#').length - 1
		},
		signUpValidation: function () {
			return {
				name: !!this.signUpForm.name,
				lastName: !!this.signUpForm.lastName,
				cellphone: !!this.signUpForm.cellphone && this.getRegexCellphone().test(this.signUpForm.cellphone),
				email: !!this.signUpForm.email && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(this.signUpForm.email),
				emailDomain: !this.isTemporaryEmail(this.signUpForm.email) && !this.isPlusAliasBlocked(this.signUpForm.email),
				password: !!this.signUpForm.password,
				passLenght: this.signUpForm.password.length >= 8 && this.signUpForm.password.length <= 100,
				passCarecteres: !!this.signUpForm.password && (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).+$/.test(this.signUpForm.password)),
				passEmail: !!this.signUpForm.password && this.signUpForm.password.indexOf(this.signUpForm.email) < 0,
				passSequence: !!this.signUpForm.password && !this.sequenceValidation(this.signUpForm.password),
				confirmPassword: !!this.signUpForm.confirmPassword &&
					(this.signUpForm.confirmPassword === this.signUpForm.password),
				// optInAge: !!this.signUpForm.optInAge,
				optInTerms: this.$t('optIns.terms') !== "true" || !!this.signUpForm.optInTerms,
				optInPrivacy: this.$t('optIns.privacy') !== "true" || !!this.signUpForm.optInPrivacy,
				optInCookie: this.$t('optIns.cookie') !== "true" || !!this.signUpForm.optInCookie,
				// day: (() => {
				// 	if (this.dateForm.day && this.dateForm.month && this.dateForm.year) {
				// 		const birthDate = moment(`${this.dateForm.year}-${this.dateForm.month.padStart(2, '0')}-${this.dateForm.day.padStart(2, '0')}`, "YYYY-MM-DD", true);
				// 		return birthDate.isValid()
				// 	}

				// 	return !!this.dateForm.day && parseInt(this.dateForm.day) >= 1 && parseInt(this.dateForm.day) <= 31;
				// })(),
				// month: !!this.dateForm.month,
				// year: (() => {
				// 	const birthDate = moment(`${this.dateForm.year}-${this.dateForm.month.padStart(2, '0')}-${this.dateForm.day.padStart(2, '0')}`, "YYYY-MM-DD", true);
				// 	if (birthDate.isValid()) {
				// 		return birthDate.isBefore(this.above18())
				// 	}
				// 	return !!this.dateForm.year
				// })(),
				birthday: !!this.signUpForm.birthday && moment(this.signUpForm.birthday, "DDMMYYYY", true).isValid()
					&& moment(this.signUpForm.birthday, "DDMMYYYY").isSameOrBefore(moment().subtract(18, "years"), "day"),
				taxId: this.cpfEnabled ? (!this.signUpForm.taxId || /^\d{11}$/.test(this.signUpForm.taxId)) : true,
				// address: !!this.signUpForm.address,
				// zipCode: (() => {
				// 	const valid = !!this.signUpForm.zipCode && /^\d{8}$/.test(this.signUpForm.zipCode);

				// 	if (!valid) {
				// 		this.zipCodeErrorMessage = 'Por favor, preencha seu CEP.';
				// 	}

				// 	return valid;
				// })(),
			}
		},
		isValid: function () {
			var ret = true
			Object.entries(this.signUpValidation).forEach(([key, value]) => {
				if (!value)
					ret = false;
			});
			return ret;
		},
		showFriendReferralCard: function () {
			const fromQuery = (this.$route.query?.extOrigin || '').toString().trim().toUpperCase()
			if (fromQuery === 'MEMBER_GET_MEMBER') return true

			const storedReferrer = getStoredReferrer()
			const fromStored = (storedReferrer?.type || '').toString().trim().toUpperCase()
			return fromStored === 'MEMBER_GET_MEMBER'
		},
		referralCodeInputDisabled() {
			return this.referralCodeLockedFromMgm || this.referralCodeLockedFromPromoter
		},
	},
	beforeRouteEnter(to, from, next) {
		window.scrollTo(0, 0);
		next();
	},
}

</script>

<template>
	<section class="auth-signup" data-qa="signup-page">
		<!-- Cadastro form ========================================== -->
		<div v-if="created === 'cadastro'" class="auth-signup__container">
			<header class="auth-signup__intro">
				<div class="auth-signup__intro-heading">
					<h1>{{ $t('signUp.newTitle') }}</h1>
					<AppButton class="auth-signup__signin" data-qa="signup-signin-link" variant="soft" :to="$router.resolve({ name: 'signin' }).path">
						{{ $t('signUp.alreadyMember') }}
					</AppButton>
				</div>
				<p>{{ $t('signUp.newDescription') }}</p>
			</header>

			<article v-if="showFriendReferralCard" class="card-amigo" aria-live="polite">
				<div class="card-amigo__icon" aria-hidden="true">
					<img :src="friendReferralCardImage" alt="" loading="lazy" width="74" height="74">
				</div>
				<div class="card-amigo__text">
					<p class="card-amigo__title">{{ $t('signUp.friendReferralTitle') }}</p>
					<p class="card-amigo__description">
						{{ $t('signUp.friendReferralDescription') }}
					</p>
				</div>
			</article>

			<section class="auth-signup__benefits" aria-labelledby="signup-benefits-title">
				<div class="auth-signup__eyebrow">
					<h2 id="signup-benefits-title">{{ $t('signUp.benefitsTitle') }}</h2>
				</div>
				<div class="auth-signup__benefits-grid">
					<article v-for="benefit in signUpBenefits" :key="benefit.title" class="auth-signup__benefit">
						<div class="auth-signup__benefit-icon" aria-hidden="true">
							<Icons :name="benefit.icon" />
						</div>
						<h3>{{ benefit.title }}</h3>
						<p>{{ benefit.description }}</p>
					</article>
				</div>
			</section>

			<form class="auth-signup__form" data-qa="signup-form" @submit.prevent="sendSignUp">
				<div class="auth-signup__section">
					<header class="auth-signup__section-header">
						<h2>{{ $t('signUp.sections.profile') }}</h2>
						<transition name="status">
							<span v-if="profileSectionComplete" class="auth-signup__complete">
								<Icons name="check" />
								{{ $t('signUp.sectionComplete') }}
							</span>
						</transition>
						<small class="auth-signup__required-fields">
							<span aria-hidden="true">*</span>
							{{ $t('signUp.requiredFieldsNote') }}
						</small>
					</header>

					<div class="row">
						<FormInput data-qa="signup-email-input" @input="log(signUpForm.email)" :label="$t('form.labels.mail')"
							v-model="signUpForm.email" inputId="mail" inputType="email"
							:placeholder="$t('form.placeholder.email')" :isRequired="true" :col="'col-100'" autocomplete="email"
							:isError="sending && !signUpValidation.email" :messageError="$t('form.messageError.email')"
							:isErrorSecondary="sending && !signUpValidation.emailDomain"
							:messageErrorSecondary="$t('form.messageError.emailDomain')" />

						<!-- Oculto por enquanto a pedido da LG -->
						<!-- <FormInput v-model="signUpForm.taxId" label="CPF" :mask="$t('form.labels.cpfMask')"
							inputId="cpf" inputType="text" placeholder="cpf*" :isRequired="true" :col="'col-100'"
							:isError="sending && !signUpValidation.taxId" messageError="Por favor, preencha seu CPF." /> -->

					</div>

					<div class="row row__combo">

						<FormInput data-qa="signup-first-name-input" :label="$t('form.labels.name')" inputId="nome" inputType="text"
							v-model="signUpForm.name" :placeholder="$t('form.labels.name')" :isRequired="true" autocomplete="given-name"
							:col="'col-100'" :isError="sending && !signUpValidation.name"
							:messageError="$t('form.messageError.name')" letters-only />

						<FormInput data-qa="signup-last-name-input" :label="$t('form.labels.sobrenome')" inputId="sobrenome"
							v-model="signUpForm.lastName" inputType="text" :placeholder="$t('form.labels.sobrenome')" autocomplete="family-name"
							:isRequired="true" :col="'col-100'" :isError="sending && !signUpValidation.lastName"
							:messageError="$t('form.messageError.lastName')" letters-only />

					</div>



					<!-- [END] New Date of Birth fields =============== -->

					<div class="row row__mobile">

						<FormInputCPF data-qa="signup-tax-id-input" v-model="signUpForm.taxId" :label="$t('form.labels.cpf')"
							:mask="$t('form.labels.cpfMask')" inputId="cpf" inputType="text"
							:placeholder="$t('form.labels.cpf')" :isRequired="false" :col="'col-100'"
							:isError="sending && !signUpValidation.taxId" :messageError="$t('form.messageError.cpf')" />

						<FormInput data-qa="signup-birth-date-input" v-model="signUpForm.birthday" :label="$t('form.labels.nascimento')"
							:mask="$t('form.labels.birthdayMask')" inputId="nascimento" inputType="text"
							:placeholder="$t('form.labels.nascimento')" :isRequired="true" :col="'col-100'" autocomplete="bday"
							:isError="sending && !signUpValidation.birthday"
							:messageError="$t('form.messageError.birthday')" />


						<FormInput data-qa="signup-cellphone-input" :label="$t('form.labels.celular')" :mask="$t('form.labels.telMask')" inputId="tel"
							v-model="signUpForm.cellphone" inputType="tel" :placeholder="$t('form.labels.celular')" autocomplete="tel"
							:isRequired="true" :col="'col-100'" :isError="sending && !signUpValidation.cellphone"
							:messageError="$t('form.messageError.cellphone')" />

					</div>

					<!-- Oculto por enquanto a pedido da LG -->
					<!-- <div class="row row__mobile">
						<FormInputSelect :label="$t('form.labels.prodTrueFalse')" :isRequired="false" :col="'col-100'"
							:messageError="$t('form.messageError.prodTrueFalse')"
							:placeholder="$t('months.selectMonth')">
							<option value="1">Sim</option>
							<option value="2">Não</option>
						</FormInputSelect>

						<FormInputSelect :label="$t('form.labels.prodType')" :isRequired="false" :col="'col-100'"
							:messageError="$t('form.messageError.prodType')" :placeholder="$t('months.selectMonth')"
							:isError="sending && !signUpValidation.prodType">
							<option value="1">Televisores</option>
							<option value="2">Áudio</option>
							<option value="3">Geladeiras</option>
							<option value="4">Lavanderia</option>
							<option value="5">Micro-ondas</option>
							<option value="6">Ar-condicionado</option>
							<option value="7">Informática</option>
							<option value="8">Outros</option>

						</FormInputSelect>

					</div> -->
				</div>

				<div class="auth-signup__section">
					<header class="auth-signup__section-header">
						<h2>{{ $t('signUp.sections.security') }}</h2>
						<transition name="status">
							<span v-if="securitySectionComplete" class="auth-signup__complete">
								<Icons name="check" />
								{{ $t('signUp.sectionComplete') }}
							</span>
						</transition>
					</header>

					<div class="row">

						<FormInput data-qa="signup-password-input" :label="$t('form.labels.passwordCreate')" inputId="password"
							v-model="signUpForm.password" :inputType="showPassword ? 'text' : 'password'"
							:placeholder="$t('form.placeholder.youPass')" :isRequired="true" :col="'col-50'" autocomplete="new-password"
							:isError="sending && !signUpValidation.password"
							:messageError="$t('form.messageError.passwordCreate')">
							<button type="button" class="toggle__password" data-qa="signup-password-toggle" @click="toggleShowPassword"
								:aria-label="showPassword ? $t('signIn.hidePassword') : $t('signIn.showPassword')"
								:title="showPassword ? $t('signIn.hidePassword') : $t('signIn.showPassword')">
								<Icons :name="showPassword ? 'eye' : 'eyeSlash'" />
							</button>
						</FormInput>

						<FormInput data-qa="signup-password-confirm-input" :label="$t('form.labels.passRepeat')" inputId="passwordRepeat"
							v-model="signUpForm.confirmPassword" :inputType="showConfirmPassword ? 'text' : 'password'"
							:placeholder="$t('form.placeholder.youPassConfirm')" :isRequired="true" :col="'col-50'" autocomplete="new-password"
							:isError="sending && !signUpValidation.confirmPassword"
							:messageError="$t('form.messageError.confirmPassword')">
							<button type="button" class="toggle__password" data-qa="signup-password-confirm-toggle" @click="toggleShowConfirmPassword"
								:aria-label="showConfirmPassword ? $t('signIn.hidePassword') : $t('signIn.showPassword')"
								:title="showConfirmPassword ? $t('signIn.hidePassword') : $t('signIn.showPassword')">
								<Icons :name="showConfirmPassword ? 'eye' : 'eyeSlash'" />
							</button>
						</FormInput>

					</div>
					<div class="auth-signup__password-rules">
						<p>{{ $t('signUp.passwordRulesTitle') }}</p>
						<ul class="pass--valid">
						<li :class="{ 'valid': (signUpValidation.passLenght) }">
							<Icons name="check" class="ckeckX" />
							<Icons name="xMark" class="xMark" /> <span>{{ $t('form.validPass.01') }}</span>
						</li>
						<li :class="{ 'valid': (signUpValidation.passCarecteres) }">
							<Icons name="check" class="ckeckX" />
							<Icons name="xMark" class="xMark" /> <span>{{ $t('form.validPass.02') }}</span>
						</li>
						<li :class="{ 'valid': (signUpValidation.passEmail) }">
							<Icons name="check" class="ckeckX" />
							<Icons name="xMark" class="xMark" /> <span>{{ $t('form.validPass.03') }}</span>
						</li>
						<li :class="{ 'valid': (signUpValidation.passSequence) }">
							<Icons name="check" class="ckeckX" />
							<Icons name="xMark" class="xMark" /> <span>{{ $t('form.validPass.04') }}</span>
						</li>
						</ul>
					</div>
				</div>

				<div class="auth-signup__section">
					<header class="auth-signup__section-header">
						<h2>{{ $t('signUp.sections.referral') }}</h2>
						<transition name="status">
							<span v-if="referralSectionComplete" class="auth-signup__complete">
								<Icons name="check" />
								{{ $t('signUp.sectionComplete') }}
							</span>
						</transition>
					</header>

					<div class="row row__referral">
						<div class="referral__box col-100">
							<div class="referral__question">
								<span class="referral__question--label">{{ $t('form.labels.referralHasCode') }}</span>
								<div class="referral__question--options">
									<label class="referral__question--option" for="has-referral-sim">
										<input id="has-referral-sim" type="checkbox" data-qa="signup-has-referral-checkbox" :checked="hasReferralCode === true"
											:disabled="referralCodeInputDisabled" @change="toggleHasReferralCode(true)"
											:aria-label="$t('form.labels.referralHasCodeYes')">
										<span>{{ $t('form.labels.referralHasCodeYes') }}</span>
									</label>
									<label class="referral__question--option" for="has-referral-nao">
										<input id="has-referral-nao" type="checkbox" data-qa="signup-no-referral-checkbox"
											:checked="hasReferralCode === false" :disabled="referralCodeInputDisabled"
											@change="toggleHasReferralCode(false)"
											:aria-label="$t('form.labels.referralHasCodeNo')">
										<span>{{ $t('form.labels.referralHasCodeNo') }}</span>
									</label>
								</div>
							</div>

							<div v-if="hasReferralCode === true" class="referral__details">
								<div class="referral__origin" role="radiogroup"
									:aria-label="$t('form.labels.referralSource')">
									<div class="referral__origin--options">
										<label class="referral__origin--option" for="referral-source-indicacao">
											<input id="referral-source-indicacao" v-model="referralSource"
												name="referralSource" type="radio" value="indicacao" data-qa="signup-referral-indication-radio"
												:disabled="referralCodeInputDisabled"
												:aria-label="$t('form.labels.referralSourceIndication')">
											<span>{{ $t('form.labels.referralSourceIndication') }}</span>
										</label>

										<label class="referral__origin--option" for="referral-source-vendedor">
											<input id="referral-source-vendedor" v-model="referralSource"
												name="referralSource" type="radio" value="vendedor" data-qa="signup-referral-seller-radio"
												:disabled="referralCodeInputDisabled"
												:aria-label="$t('form.labels.referralSourceSeller')">
											<span>{{ $t('form.labels.referralSourceSeller') }}</span>
										</label>
									</div>
								</div>

								<div class="referral__code">
									<FormInput data-qa="signup-referral-code-input" :label="$t('form.labels.referralCode')" inputId="referral-code"
										v-model="referralCode" inputType="text"
										:placeholder="$t('form.placeholder.referralCode')" :isRequired="false"
										:col="'col-100'" :showLabel="false" :isDisabled="referralCodeInputDisabled" />
								</div>
							</div>
						</div>
					</div>






				</div>
				<div class="auth-signup__consents">

					<!-- MOVOS ========== -->
					<div class="checkbox-wrapper col-100">
						<div>
							<input id="signup-terms" v-model="signUpForm.optInTerms" type="checkbox" data-qa="signup-terms-checkbox">
							<label for="signup-terms" v-html="$t('form.labels.optInTerms')"></label>
						</div>
						<span class="alertErro" v-show="sending && !signUpValidation.optInTerms">{{
							$t('form.messageError.optInPrivacy') }}</span>
					</div>

					<div class="checkbox-wrapper col-100">
						<div>
							<input id="signup-cookie" v-model="signUpForm.optInCookie" type="checkbox" data-qa="signup-cookie-checkbox">
							<label for="signup-cookie" v-html="$t('form.labels.optInCookie')"></label>
						</div>
						<span class="alertErro" v-show="sending && !signUpValidation.optInCookie">{{
							$t('form.messageError.optInPrivacy') }}</span>
					</div>

					<div class="checkbox-wrapper col-100">
						<div>
							<input id="signup-privacy" v-model="signUpForm.optInPrivacy" type="checkbox" data-qa="signup-privacy-checkbox">
							<label for="signup-privacy" v-html="$t('form.labels.optInPrivacy')"></label>
						</div>
						<span class="alertErro" v-show="sending && !signUpValidation.optInPrivacy">{{
							$t('form.messageError.optInPrivacy') }}</span>
					</div>

				</div>
				<span class="serverReturn" v-show="feedback" data-qa="signup-feedback-error">{{ feedback }}</span>
				<div class="auth-signup__actions">
					<AppButton data-qa="signup-submit-button" type="submit" :disabled="isSubmitting" :loading="isSubmitting" variant="primary">{{
						$t('buttons.finalizarCadastro') }}
					</AppButton>
				</div>
			</form>


		</div>
		<!-- Cadastro form ========================================== -->

		<!-- Cadastro finalizado ========================================== -->
		<div v-if="created === '!finalizacao'" class="signUp--finish">
			<header>
				<hgroup>
					<h1 v-html="$t('signUp.titleSignUpThanks')"></h1>
					<p v-html="$t('signUp.descSignUpThanks')"></p>
				</hgroup>
			</header>

			<div class="grid" data-qa="signup-finish-section">
				<div class="product-choice" role="radiogroup" :aria-label="$t('signUp.titleSignUpThanks')">
					<button
						type="button"
						class="product-choice__card"
						:class="{ 'is-selected': cadastroProdutos }"
						data-qa="signup-products-now-radio"
						role="radio"
						:aria-checked="cadastroProdutos"
						@click="showProdutos"
					>
						<Icons name="productRegister" class="product-choice__icon" aria-hidden="true" />
						<span class="product-choice__label">{{ $t('signUp.signUpOpt2') }}</span>
					</button>
					<button
						type="button"
						class="product-choice__card"
						:class="{ 'is-selected': !cadastroProdutos }"
						data-qa="signup-products-later-radio"
						role="radio"
						:aria-checked="!cadastroProdutos"
						@click="showFinalizar"
					>
						<Icons name="productLater" class="product-choice__icon" aria-hidden="true" />
						<span class="product-choice__label">{{ $t('signUp.signUpOpt1') }}</span>
					</button>
				</div>

				<transition name="fade">
					<ProductRegisterFlow
						data-qa="signup-products-form"
						v-show="cadastroProdutos"
						:categories="categories"
						:sub-categories="subCategories"
						:is-saving="isRegisteringProduct"
						@load-sub-categories="onFlowCategory"
						@save="onFlowSave"
					/>
				</transition>

				<p v-show="!cadastroProdutos" class="product-choice__later" data-qa="signup-products-later-note">{{ $t('signUp.laterNote') }}</p>


				<div class="row buttons--wrap finalizar">
					<Button data-qa="signup-go-login-button" type="primary" :buttonText="$t('buttons.goLogin')"
						@interceptAccess="interceptAccess(this.$router.resolve({ name: 'signin', query: { ativarConta: true } }).path)" />
				</div>
			</div>
		</div>
		<!-- Cadastro finalizado ========================================== -->

		<ValidateMail v-if="created === 'validate'" :key="validateMessageType" :message-type="validateMessageType"
			:feedback="validateMessageFeedback" @reenviar="resendValidationEmail"
			@voltar="interceptAccess(this.$router.resolve({ name: 'signin' }).path)" />

	</section>
</template>

<style lang="sass" scoped>
@use '../assets/sass/utilities/_colors' as *
@use '../assets/sass/utilities/_responsive' as *
@use '../assets/sass/utilities/_mixin' as *

.fade-enter-active,
.fade-leave-active
	transition: opacity 0.5s ease

.fade-enter,
.fade-leave-to
	opacity: 0

.clear
	clear: both	
	display: block

.row__mobile
	flex-wrap: nowrap !important

.wrapper
	width: min(100%, 708px)
	margin-inline: auto
	margin-block: 4rem

	hgroup
		margin-bottom: 2.4rem
		
		h1
			font-weight: 300
			font-size: clamp( 1.75rem, var(--clamp), 2.25rem)


	.row
		gap: 12px
	
		
		&.checkbox
			gap: 10px
			margin-top: 1rem
		
		&.buttons--wrap
			margin-top: 2rem
			justify-content: center


.signUp, .signUp--finish
	padding-inline: 1.25rem
	+respond-to($breakpoint-sm-min)	
		padding-inline: 0	

.card-amigo
	background: var(--white)
	border-radius: 1rem
	box-shadow: var(--shadow-default)
	display: flex
	gap: 1rem
	justify-content: center
	align-items: center
	padding: 1rem
	width: min(100%, 540px)
	margin-inline: auto
	margin-bottom: 1.5rem

	+respond-to($breakpoint-sm-min)
		padding: 1.5rem

	&__icon
		background: var(--lg-light-gray-200)
		border-radius: 99px
		width: 74px
		height: 74px
		display: flex
		align-items: center
		justify-content: center
		flex-shrink: 0
		overflow: hidden

		img
			width: 100%
			height: 100%
			object-fit: contain

	&__text
		display: flex
		flex-direction: column
		gap: 0.5rem
		min-width: 0

	&__title
		font-family: var(--lgei-headline)
		color: var(--lg-red-active)
		font-size: 1.125rem
		line-height: 1.2
		font-weight: 600

	&__description
		font-family: var(--lgei-headline)
		color: var(--club--text-default)
		font-size: 1.25rem
		line-height: 1.2
		font-weight: 600

.checkbox-wrapper
	font-size: 14px
	align-items: flex-start

.row__referral
	flex-direction: column
	gap: 0.75rem !important

.referral__box
	background: var(--lg-light-gray-200)
	border-radius: 8px
	padding: 1rem
	display: flex
	flex-direction: column
	gap: 0
	width: 100%

.referral__question
	display: flex
	flex-direction: row
	flex-wrap: wrap
	align-items: center
	gap: .8rem

	&--label
		font-size: .875rem
		color: var(--club--text-default)
		flex-shrink: 0
		font-weight: 600

	&--options
		display: flex
		flex-direction: row
		gap: 1rem

	&--option
		width: fit-content
		display: inline-flex
		align-items: center
		gap: .375rem
		font-size: .875rem
		color: var(--club--text-default)
		cursor: pointer

		input[type='checkbox']
			--size-input: 0.875rem
			--active: var(--lg-red-active)
			--active-inner: var(--white)
			--border: var(--color-grey-100)
			--border-hover: var(--lg-red-active)
			--background: var(--white)
			-webkit-appearance: none
			-moz-appearance: none
			appearance: none
			width: var(--size-input)
			height: var(--size-input)
			margin: 0
			border: 1px solid var(--border)
			border-radius: 2px
			background: var(--background)
			position: relative
			transition: background .2s ease, border-color .2s ease
			cursor: pointer
			flex-shrink: 0

			&::after
				content: ''
				position: absolute
				width: 60%
				height: 35%
				top: 30%
				left: 50%
				transform: translate(-50%, -10%) rotate(-45deg)
				border-left: 2px solid var(--active-inner)
				border-bottom: 2px solid var(--active-inner)
				opacity: 0
				transition: opacity .15s ease

			&:checked
				background: var(--active)
				border-color: var(--active)

				&::after
					opacity: 1

			&:hover:not(:checked)
				border-color: var(--border-hover)

			&:focus-visible
				outline: 2px solid rgba(var(--lg-red-active-rgb), 0.4)
				outline-offset: 2px

.referral__details
	margin-top: .75rem

.referral__origin
	display: flex
	flex-direction: column
	gap: 0.5rem

	&--options
		display: flex
		flex-direction: row
		flex-wrap: wrap
		gap: .5rem

	&--option
		width: fit-content
		display: inline-flex
		align-items: center
		gap: .5rem
		font-size: .875rem
		color: var(--club--text-default)
		cursor: pointer

		input[type='radio']
			--size-input: 1rem
			--active: var(--lg-red-active)
			--active-inner: var(--white)
			--focus: 2px rgba(var(--lg-red-active-rgb), 0.3)
			--border: var(--color-grey-100)
			--border-hover: var(--lg-red-active)
			--background: var(--white)
			-webkit-appearance: none
			-moz-appearance: none
			appearance: none
			width: var(--size-input)
			height: var(--size-input)
			margin: 0
			border: 1px solid var(--border)
			border-radius: 50%
			background: var(--background)
			position: relative
			transition: background .2s ease, border-color .2s ease, box-shadow .2s ease
			cursor: pointer

			&::after
				content: ''
				position: absolute
				width: calc(var(--size-input) / 2.7)
				height: calc(var(--size-input) / 2.7)
				top: 50%
				left: 50%
				transform: translate(-50%, -50%) scale(0.6)
				border-radius: 50%
				background: var(--active-inner)
				opacity: 0
				transition: opacity .2s ease, transform .2s ease

			&:checked
				border-color: var(--active)
				background: var(--active)

				&::after
					opacity: 1
					transform: translate(-50%, -50%) scale(1)

			&:hover:not(:checked)
				border-color: var(--border-hover)

			&:focus-visible
				box-shadow: 0 0 0 var(--focus)

	+respond-to($breakpoint-sm-min)
		&--options
			gap: 1.25rem

.referral__code
	margin-top: .875rem
	width: 100%

.signUp--finish

	header
		display: flex
		flex-direction: column
		align-items: center
		border-bottom: 1px solid var(--color-grey-1300)

		hgroup
			margin-bottom: 1.5rem
			text-align: center
			
			h1
				color: var(--lg-red-active)
				
				font-size: clamp( 1.6rem, var(--clamp), 2rem)
				margin-bottom: 0.5rem
				text-wrap: balance

			p	
				color: var(--color-grey-1400)
				font-size: 1.125rem
				text-wrap: balance

		figure
			max-width: 140px

			img
				width: 100%

	.box--combo
		display: flex
		flex-direction: column
		align-items: flex-start
		margin-inline: auto
		gap: 1rem
		margin-block: 2rem
		+respond-to($breakpoint-sm-min)
			flex-direction: row
			gap: 2rem


.row__combo
	flex-wrap: wrap !important
	+respond-to($breakpoint-sm-min)
		flex-wrap: nowrap !important
	


.auth-signup
	flex: 1
	width: 100%
	max-width: 100%
	padding: clamp(2.5rem, 6vw, 5rem) 1.25rem
	background: var(--lg-light-gray-100)
	overflow-x: hidden

	&__container
		width: min(100%, 52.5rem)
		min-width: 0
		margin-inline: auto
		animation: signupFadeUp .5s ease

	&__intro
		h1
			font-family: var(--lgei-headline)
			font-size: clamp(2.25rem, 6vw, 2.75rem)
			font-weight: 700
			letter-spacing: -.025em

		> p
			max-width: 36rem
			margin-top: .65rem
			color: var(--club--text-default)
			font-size: 1.125rem
			line-height: 1.5

	&__intro-heading
		display: flex
		align-items: center
		justify-content: space-between
		flex-wrap: wrap
		gap: 1rem

	&__benefits
		margin-block: 1.75rem 2.75rem

	&__eyebrow
		display: flex
		align-items: center
		gap: .75rem
		margin-bottom: 1rem

		&::after
			content: ''
			flex: 1
			height: 1px
			background: var(--lg-light-gray-300)

		h2
			color: var(--lg-red)
			font-size: .75rem
			font-weight: 700
			letter-spacing: .1em
			text-transform: uppercase

	&__benefits-grid
		display: grid
		grid-template-columns: repeat(2, minmax(0, 1fr))
		gap: 1rem

	&__benefit
		min-width: 0
		padding: 1.25rem
		border-radius: 1rem
		background: var(--white)
		box-shadow: var(--shadow-default)

		h3
			margin-top: 1rem
			font-family: var(--lgei-headline)
			font-size: .95rem
			font-weight: 700

		p
			margin-top: .25rem
			color: var(--color-grey-700)
			font-size: .8125rem
			line-height: 1.45

	&__benefit-icon
		width: 2.875rem
		height: 2.875rem
		padding: .7rem
		border-radius: .8rem
		background: rgba(var(--lg-red-active-rgb), .1)
		color: var(--lg-red-active)

	&__form
		width: 100%
		min-width: 0
		padding: clamp(1.25rem, 5vw, 2.5rem)
		border-radius: 1.25rem
		background: var(--white)
		box-shadow: var(--shadow-default)

	&__section
		padding-block: 1.75rem
		border-bottom: 1px solid var(--lg-light-gray-200)

		&:first-child
			padding-top: 0

		> .row
			gap: 1rem

	&__section-header
		display: flex
		align-items: center
		flex-wrap: wrap
		gap: .75rem
		margin-bottom: 1.25rem

		h2
			color: var(--color-grey-500)
			font-size: .8125rem
			font-weight: 700
			letter-spacing: .08em
			text-transform: uppercase

	&__complete
		display: inline-flex
		align-items: center
		gap: .3rem
		padding: .2rem .65rem
		border-radius: 999px
		background: rgba(var(--lg-green-validation-rgb), .12)
		color: var(--lg-green-validation)
		font-size: .6875rem
		font-weight: 700
		letter-spacing: .04em
		text-transform: uppercase

		i
			width: .8rem
			height: .8rem

	&__required-fields
		margin-left: auto
		color: var(--club--text-default)
		font-family: var(--lgei-text)
		font-size: .75rem
		line-height: 1.4
		text-align: right
		white-space: nowrap

		span
			color: var(--lg-red-active)

	&__password-rules
		margin-top: 1rem
		padding: 1.125rem 1.25rem
		border-radius: .875rem
		background: var(--lg-light-gray-100)

		> p
			margin-bottom: .75rem
			color: var(--club--text-default)
			font-size: 1rem
			font-weight: 700

		.pass--valid
			display: grid
			gap: .6rem
			padding: 0
			border-radius: 0
			background: transparent

			li
				align-items: center
				gap: .625rem
				margin: 0
				color: var(--club--text-default)
				font-size: .95rem
				line-height: 1.35

				i
					width: 1.25rem
					height: 1.25rem
					padding: .2rem
					border: 2px solid var(--color-grey-500)
					background: transparent

					&.xMark
						border-color: var(--color-grey-500)
						background: transparent

						:deep(svg)
							display: none

				&.valid
					color: var(--club--text-default)

					i.ckeckX
						display: block
						border-color: var(--green-10)
						background: var(--green-10)

	&__consents
		display: grid
		gap: 1.25rem
		padding-top: 1.5rem

	&__actions
		display: flex
		justify-content: center
		margin-top: 2rem

	+respond-to($breakpoint-lg-min)
		&__benefits-grid
			grid-template-columns: repeat(4, minmax(0, 1fr))

		.row__combo
			display: grid
			grid-template-columns: repeat(2, minmax(0, 1fr))

		.row__mobile
			display: grid
			grid-template-columns: repeat(3, minmax(0, 1fr))

.auth-signup .card-amigo
	width: 100%
	margin: 1.5rem 0 0
	justify-content: flex-start
	box-shadow: var(--shadow-default)

	.card-amigo__title
		font-size: 1rem

	.card-amigo__description
		font-family: var(--lgei-text)
		font-size: .95rem
		line-height: 1.35

.auth-signup .referral__box
	padding: 0
	background: transparent

.auth-signup .referral__question--option
	position: relative

	input[type='checkbox']
		position: absolute
		opacity: 0

		&:checked + span
			border-color: var(--lg-red-active)
			background: rgba(var(--lg-red-active-rgb), .1)
			color: var(--lg-red-active)

		&:focus-visible + span
			outline: 2px solid rgba(var(--lg-red-active-rgb), .35)
			outline-offset: 2px

		&:disabled + span
			opacity: .6
			cursor: not-allowed

	span
		display: block
		padding: .55rem 1.25rem
		border: 1px solid var(--lg-light-gray-300)
		border-radius: 999px
		font-weight: 600

.auth-signup .referral__details
	margin-top: 1rem
	padding: 1.125rem 1.25rem
	border-radius: .875rem
	background: var(--lg-light-gray-100)

.auth-signup .checkbox-wrapper
	width: 100%
	font-size: 1rem

	> div
		display: grid
		grid-template-columns: 1.25rem minmax(0, 1fr)
		align-items: flex-start
		justify-content: flex-start
		gap: .75rem

	input[type='checkbox']
		--size-input: 1.25rem
		margin-top: .1rem

	label
		margin-left: 0
		color: var(--club--text-default)
		font-family: var(--lgei-text)
		font-size: 1rem
		line-height: 1.5

		:deep(a)
			color: var(--lg-red-active)
			text-decoration: underline
			text-underline-offset: .12em

	input:focus-visible
		outline: 2px solid rgba(var(--lg-red-active-rgb), .35)
		outline-offset: 2px

.auth-signup .serverReturn
	display: block
	width: fit-content
	max-width: 100%
	margin: 1.5rem 0 0
	line-height: 1.4

.auth-signup :deep(.box--form .input-wrapper input)
	border: 1px solid var(--lg-light-gray-300)

	&:focus-visible
		border-color: var(--lg-red-active)
		outline: 2px solid rgba(var(--lg-red-active-rgb), .2)
		outline-offset: 1px

.auth-signup .signUp--finish .grid
	flex-wrap: nowrap
	gap: 1.5rem
	align-items: center

.auth-signup .signUp--finish :deep(.product-flow__footer)
	width: 100%
	align-items: center

.auth-signup .signUp--finish .buttons--wrap.finalizar
	margin-top: 0

.product-choice
	display: flex
	flex-wrap: wrap
	justify-content: center
	gap: 1.25rem
	width: 100%
	margin-block: 1.25rem 2.25rem

	&__card
		display: flex
		align-items: center
		gap: 0.75rem
		min-width: 14rem
		padding: 1.125rem 1.5rem
		border: 1px solid var(--lg-light-gray-300)
		border-radius: 0.875rem
		background: var(--white)
		cursor: pointer
		font-family: inherit
		transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease

		&:hover
			border-color: var(--lg-dark-gray-200)

		&.is-selected
			border: 2px solid var(--lg-dark-gray-200)
			background: rgba(var(--lg-dark-gray-300-rgb), 0.05)

	&__icon
		display: grid
		place-items: center
		flex: 0 0 auto
		width: 1.75rem
		height: 1.75rem
		color: var(--lg-dark-gray-200)

		:deep(svg)
			width: 100%
			height: 100%

	&__label
		font-size: 1rem
		font-weight: 500
		color: var(--lg-dark-gray-200)

	&__later
		width: 100%
		max-width: 34rem
		margin: 0 auto
		text-align: center
		font-family: var(--lgei-text)
		font-size: 1rem
		line-height: 1.5
		text-wrap: balance
		color: var(--lg-mid-gray-200)

.auth-signup .signUp--finish
	width: min(100%, 60rem)
	margin-inline: auto
	padding: 2rem
	border-radius: 1.25rem
	background: var(--white)

.status-enter-active,
.status-leave-active
	transition: opacity .25s ease, transform .25s ease

.status-enter-from,
.status-leave-to
	opacity: 0
	transform: translateY(.25rem)

@keyframes signupFadeUp
	from
		opacity: 0
		transform: translateY(.75rem)
	to
		opacity: 1
		transform: none

@media (prefers-reduced-motion: reduce)
	.auth-signup__container
		animation: none

	.status-enter-active,
	.status-leave-active
		transition: none

+respond-to($sm-device-max)
	.auth-signup
		padding-inline: 1rem

	.auth-signup__benefits-grid
		grid-template-columns: repeat(2, minmax(0, 1fr))

	.auth-signup__benefit-icon
		flex: 0 0 2.25rem
		width: 2.25rem
		height: 2.25rem
		padding: .5rem

	.auth-signup__benefit p
		display: none

	.auth-signup__benefit
		display: flex
		align-items: center
		gap: .5rem
		padding-inline: .5rem
		padding-block: .875rem

		h3
			margin-top: 0
			font-size: .8125rem

	.auth-signup__intro
		display: flex
		flex-direction: column

	.auth-signup__intro-heading
		display: contents

		h1
			order: 1

	.auth-signup__intro > p
		order: 2

	.auth-signup__signin
		align-self: flex-start
		order: 3
		margin-top: 1rem

	.auth-signup__benefits
		margin-bottom: 2rem

	.auth-signup__form
		padding-inline: 1rem

	.auth-signup .row,
	.auth-signup .row__combo,
	.auth-signup .row__mobile
		min-width: 0
		flex-wrap: wrap !important

	.auth-signup .card-amigo
		align-items: flex-start

		.card-amigo__icon
			width: 3.5rem
			height: 3.5rem

</style>
